import React from 'react';
import { Linking } from 'react-native';

import { ConfirmModal } from '@/ui/confirm-modal';

const SUPPORT_PHONE = '+18555987090';
const SUPPORT_EMAIL = 'support@eonrides.com';

interface ContactSupportModalProps {
  isVisible: boolean;
  onDismiss: () => void;
}

export default function ContactSupportModal({
  isVisible,
  onDismiss,
}: ContactSupportModalProps) {
  return (
    <ConfirmModal
      isVisible={isVisible}
      titleTx="contactSupport.title"
      bodyTx="contactSupport.body"
      leftButton={{
        tx: 'contactSupport.email',
        style: { width: 'auto', minWidth: 250 },
        onPress: () => {
          Linking.openURL(`mailto:${SUPPORT_EMAIL}`);
          onDismiss();
        },
      }}
      rightButton={{
        tx: 'contactSupport.call',
        onPress: () => {
          Linking.openURL(`tel:${SUPPORT_PHONE}`);
          onDismiss();
        },
      }}
      onDismiss={onDismiss}
    />
  );
}
